import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Paper from 'material-ui/Paper';
import Divider from 'material-ui/Divider';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import Snackbar from 'material-ui/Snackbar';
import ErrorIcon from 'material-ui/svg-icons/alert/error-outline';
import Person from 'material-ui/svg-icons/social/person';
import { connect } from 'react-redux';
import { loginRequest } from '../../redux/actions';
import Register from './Register';
import ErrorBox from '../common/ErrorBox';
import CircularProgress from 'material-ui/CircularProgress';

const styles = {
    textFields: {
        width:"auto"
    }
};

const paperStyle = {
    width: 'auto',
    height: 'auto',
    margin: '10px',
}

const paperContentStyle = {
    padding: '30px',
    paddingTop: '0px',
    paddingBottom: '15px'
}

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            emailValue: '',
            passwordValue: '',
            emailErrorText: '',
            passwordErrorText: '',
            open: false
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillReceiveProps({isLoggedIn}) {
        if(isLoggedIn) {
            this.handleClose();
        }
    }

    handleOpen = () => this.setState({open: true});

    handleClose = () => this.setState({open: false});

    handleSubmit() {
        const { emailValue, passwordValue, emailErrorText, passwordErrorText } = this.state;
        const { isLoggedIn, onLogin } = this.props;

        if (emailValue === '') {
            this.setState( { emailErrorText: 'This field is required' });
        }
        if (passwordValue === '') {
            this.setState( { passwordErrorText: 'This field is required' });
        }
        if (isLoggedIn == false && emailValue != '' && passwordValue != '') {
            onLogin(emailValue, passwordValue);
        }
    }

    render() {
        const { trigger, onLogin, isLoggedIn, error, loading } = this.props;
        var { open, emailValue, passwordValue, emailErrorText, passwordErrorText } = this.state;

        var emailField = <TextField
            style={styles.textFields} 
            floatingLabelText="Email"
            errorText = { emailErrorText }
            onChange = { (e, value) => { 
                this.setState({ emailValue: value });
                this.setState({ emailErrorText: '' });
            }}
        />;
    
        var passwordField = <TextField
            style={styles.textFields}
            floatingLabelText="Password"
            type="password"
            errorText = { passwordErrorText }
            onChange = { (e, value) => { 
                this.setState({ passwordValue: value });
                this.setState({ passwordErrorText: '' });
            }}    
        />;
    
        const submitButton = <RaisedButton primary={true}
            type='submit'
            label='Login' 
            icon={loading ? <CircularProgress size={20} thickness={3} /> : undefined}
            onClick={ (e) => {
                e.preventDefault();
                this.handleSubmit();
            }}
        />;

        const registerButton = <RaisedButton secondary={true}
            label='Register'
            containerElement={<Link to='/Register'/>}
            onClick={ () => {
                this.handleClose();
            }}
        />;

        const forgotPassword = <Link to='/forgot'>
            Forgot your password?
        </Link>
    
        if (isLoggedIn) {
            return null;
        } else {
            return <div onTouchTap={this.handleOpen}>
            { trigger }
            <Dialog
                modal={false}
                open={open}
                onRequestClose={this.handleClose} 
            >
            <Grid fluid>
                <Row>
                    <Col xs= { 12 }>
                        <Row center="sm">
                            <Col xs={ 12 }>
                                <div style={ paperContentStyle }>
                                    <h1>Login</h1>
                                    <ErrorBox open={error} text="Invalid Login Credentials"/>
                                    <form>
                                        <Row>                                        
                                            <Col xs={12} sm={6}>
                                                { emailField }
                                            </Col>
                                            <Col xs={12} sm={6}>
                                                { passwordField }
                                            </Col>
                                        </Row>
                                        <br />
                                        { submitButton }
                                        <br />
                                        <br />
                                        { forgotPassword }
                                    </form>
                                    <br />
                                </div>
                                <Divider />
                                <div style={ paperContentStyle }>
                                    <h4>Don't have an account?</h4>
                                    { registerButton }
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Grid>
        </Dialog>
        </div>;
        }
    }
}

function mapDispatchToProps(dispatch) {
    return { onLogin: (email, password) => dispatch(loginRequest(email, password)) };
}

function mapStateToProps({auth}) {
    return { isLoggedIn: auth.logged, error: auth.error, loading: auth.loading };
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);


// WEBPACK FOOTER //
// ./src/components/auth/Login.js